module.exports = __webpack_public_path__ + "sj.fa6eb2590abd4d707fa9.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sj.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sj.svg
// module chunks = styles